<template>
  <div class="flex w-full flex-col gap-y-4 py-4">
    <div v-for="scorecardResult in value" :key="scorecardResult.id">
      <div class="flex h-[34px] items-center justify-center">
        <risk-tier
          v-if="scorecardResult.score_card_risk_tier"
          :model-value="scorecardResult.score_card_risk_tier.indicator"
          uppercase
          bordered
          class="mr-1"
        />
      </div>
    </div>
    <lf-badge v-if="!value?.length" is-rounded class="font-semibold">
      <span class="px-4">-</span>
    </lf-badge>
  </div>
</template>
<script lang="ts" setup>
import RiskTier from "@/components/RiskTier.vue";
import LfBadge from "@/components/ui/LfBadge.vue";

import type { IScorecardResult } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  value: {
    type: Array as PropType<IScorecardResult[]>,
  },
});
</script>
